// Resizable chat panel width bounds (px). MIN must be wide enough for the
// composer's bottom toolbar (symbol/reference icons + model picker + send
// button, and its 300px-wide dropdown) to render without clipping against
// the panel's own overflow-hidden edge.
export const MIN_CHAT_WIDTH = 410;
export const MAX_CHAT_WIDTH = 720;
export const DEFAULT_CHAT_WIDTH = 480;
// The editor beside the chat keeps at least this much room, so its toolbar
// (Preview / Publish) never gets pushed out of view by a wide chat.
export const MIN_EDITOR_WIDTH = 560;

export const clampChatWidth = (w) => Math.min(MAX_CHAT_WIDTH, Math.max(MIN_CHAT_WIDTH, w));

/**
 * Chat width to actually show inside a container `containerWidth` px wide:
 * the teacher's chosen width, narrowed if it would squeeze the editor below
 * MIN_EDITOR_WIDTH — but never below MIN_CHAT_WIDTH.
 */
export function fitChatWidth(chatWidth, containerWidth) {
  if (!containerWidth) return chatWidth;
  return Math.max(MIN_CHAT_WIDTH, Math.min(chatWidth, containerWidth - MIN_EDITOR_WIDTH));
}
